<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-2 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <h1>Daftar</h1>
                <p class="text-muted">Buat Akun WebSMSmu</p>
                <CAlert
                  color="success"
                  closeButton
                  :show.sync="alert.show"
                >
                  {{ alert.content }}
                </CAlert>
                <CRow>
                  <CCol md="6">
                    <CInput 
                      add-input-classes="text-capitalize"
                      placeholder="Nama Bisnis" 
                      v-model="data.business_name"
                      :invalid-feedback="errors.business_name ? errors.business_name[0]:''"
                      :is-valid="errors.business_name ? false:null"
                    >
                      <template #prepend-content><CIcon name="cil-user"/></template>
                    </CInput>
                  </CCol>
                  <CCol md="6">
                    <CInput 
                      add-input-classes="text-capitalize"
                      placeholder="Penanggung Jawab" 
                      v-model="data.pic"
                      :invalid-feedback="errors.pic ? errors.pic[0]:''"
                      :is-valid="errors.pic ? false:null"
                    >
                      <template #prepend-content><CIcon name="cil-user"/></template>
                    </CInput>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="6">
                    <CInput
                      placeholder="Email"
                      prepend="@"
                      v-model="data.email"
                      :invalid-feedback="errors.email ? errors.email[0]:''"
                      :is-valid="errors.email ? false:null"
                    />
                  </CCol>
                  <CCol md="6">
                    <CInput
                      placeholder="No. Handphone"
                      type="tel"
                      v-model="data.phone"
                      :invalid-feedback="errors.phone ? errors.phone[0]:''"
                      :is-valid="errors.phone ? false:null"
                    >
                      <template #prepend-content><CIcon name="cil-user"/></template>
                    </CInput>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="6">
                    <CInput
                      placeholder="Password"
                      type="password"
                      v-model="data.password"
                      :invalid-feedback="errors.password ? errors.password[0]:''"
                      :is-valid="errors.password ? false:null"
                    >
                      <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                    </CInput>
                  </CCol>
                  <CCol md="6">
                    <CInput
                      placeholder="Ulangi password"
                      type="password"
                      class="mb-4"
                      v-model="data.password_confirmation"
                      :invalid-feedback="errors.password_confirmation ? errors.password_confirmation[0]:''"
                      :is-valid="errors.password_confirmation ? false:null"
                    >
                      <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                    </CInput>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="12" style="margin-bottom:20px;">
                    <vue-recaptcha
                        sitekey="6LeF5eUcAAAAAFnVhZV3_5Db8rRh6oyyK2xQIB8W"
                        :loadRecaptchaScript="true"
                        ref="recaptcha"
                        type="invisible"
                        @verify="onCaptchaVerified"
                        @expired="onCaptchaExpired"
                      >
                    </vue-recaptcha>
                    <p class="text-danger" v-if="errors.recaptcha"><small><i>{{ errors.recaptcha[0] }}</i></small></p>
                  </CCol>
                </CRow>
                <ButtonLoader 
                  :loading="loading.submit" 
                  :styled="'btn btn-success btn-block'" 
                  @click.native="submit()">
                    Masuk
                </ButtonLoader>
              </CForm>
            </CCardBody>
            <CCardFooter class="p-4">
              <CRow>
                <CCol col="12" class="text-center">
                  <p>Sudah Punya Akun WebSMS?</p>
                  <CButton color="primary" class="px-4" @click="$router.push({name: 'Login'})">Masuk</CButton>
                </CCol>
              </CRow>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import $axios from './../../api.js'
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'Register',
  components: { 'vue-recaptcha' : VueRecaptcha },
  data(){
    return{
      alert:{
        show: false,
        content: ''
      },
      loading:{
        submit: false
      },
      data:{
        business_name: '',
        pic: '',
        email: '',
        phone: '',
        password: '',
        password_confirmation: '',
        recaptcha: ''
      }
      
    }
  },
  created(){
    if (this.isAuth) {
      this.$router.push({ name: 'Home' })
    }
  },
  computed:{
    ...mapState(['errors']),
    ...mapGetters(['isAuth']),
  },
  methods:{
    onCaptchaVerified: function (recaptchaToken) {
      this.data.recaptcha = recaptchaToken
      console.log(recaptchaToken)
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    submit(){
      this.$store.commit('CLEAR_ERRORS')
      this.loading.submit = true
      $axios.post('/auth/register', this.data)
      .then((response) => {
        this.loading.submit = false
        this.alert = {
          show: true,
          content: 'Pendaftaran berhasil, silahkan kembali kehalaman Login'
        }
      })
      .catch((error) => {
        this.loading.submit = false
        if (error.response.status == 422) {
          this.$store.commit('SET_ERRORS', error.response.data.errors, { root: true })
        }
        console.log(this.errors)
        
      })
    }
  },
  destroyed(){
    this.$store.commit('CLEAR_ERRORS')
  }
}
</script>
